module.exports = __webpack_public_path__ + "static/media/megaphone.7383981c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/megaphone.png
// module id = 267
// module chunks = 0